import { createSelector } from 'reselect'
import { ONE_MONTH_MS } from '../../domain/utils/date'
import { selectUIState } from './ui.selectors'

import { selectIsAGeoentityOnSearchPage, selectIsItineraryUniverse } from '../history/history.selectors'
import { selectIsFrenchSite } from '../locale/locale.selectors'

const selectNPSSurvey = createSelector(selectUIState, ui => ui?.survey)

const selectNPSSurveyLastTimeClosed = createSelector(selectNPSSurvey, survey => survey?.lastTimeClosed)

export const selectShouldShowNPSSurvey = createSelector(
  selectIsFrenchSite,
  selectNPSSurveyLastTimeClosed,
  selectIsItineraryUniverse,
  selectIsAGeoentityOnSearchPage,
  (localeFR, lastTimeClosed, itineraryUniverse, geoentitySearchPage) => {
    if (!localeFR || (!itineraryUniverse && !geoentitySearchPage)) return false
    return !lastTimeClosed || Date.now() - lastTimeClosed > ONE_MONTH_MS
  }
)
